// Stella a 8 punte di Claude ("sta pensando"); colore corrente (accent via CSS .spark).
export function Spark({ className = 'spark' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 0l1.8 8.2L20.5 3.5l-4.7 6.7L24 12l-8.2 1.8 4.7 6.7-6.7-4.7L12 24l-1.8-8.2-6.7 4.7 4.7-6.7L0 12l8.2-1.8L3.5 3.5l6.7 4.7L12 0z" />
    </svg>
  );
}
